import React, { useEffect } from "react";
import '../css-coding/popup.css';

import Edit from "../assets/GE.png";
import Design from "../assets/gd.jpeg";

const courses = [
  {
    id: 1,
    image: Design,
    title: "Ultimate Graphic Design Masterclass",
    subtitle: "Become a G.O.A.T in Design ! | தமிழ்",
    link: "https://itsprakashhere.in/graphicdesign/",
  },
  {
    id: 2,
    image: Edit,
    title: "Join Reels Editing Masterclass",
    subtitle: "Become a G.O.A.T in Video Editing | தமிழ்",
    link: "https://itsprakashhere.in/reels/",
  },
];

const CoursesPopup = ({ isOpen, onClose }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="courses-overlay" onClick={onClose}>
      <div className="courses-modal" onClick={(e) => e.stopPropagation()}>
         <button className="popup-close" onClick={onClose}>
     <span>×</span>
    </button>
        {courses.map((course) => (
          <div className="course-card" key={course.id}>
            <img src={course.image} alt={course.title} />

            <div className="course-info">
              <h3>{course.title}</h3>
              <p>{course.subtitle}</p>
            </div>

            <a
              href={course.link}
              target="_blank"
              rel="noopener noreferrer"
              className="course-btn"
            >
              Course Link
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursesPopup;